import(/* webpackMode: "eager" */ "/opt/build/repo/app/(chat)/layout.tsx");
